<template>
    <div>
        <card-list :data-headers="tHeaders" title="Supplier List" data-size="10"
                   data-url="/api/v1/supplier" edit-route="/master/supplier/add"
                   delete-endpoint=""/>
    </div>
</template>
<script>
    import CardList from "../../components/CardList";

    export default {
        name: "SupplierList",
        components: {
            CardList,
        },
        data() {
            return {
                tHeaders: [
                    {name: "Nama", align: 'left'},
                    {perusahaan: "Perusahaan", align: 'left'},
                    {address: "Alamat", align: 'left'},
                    {phone: "Phone", align: 'left'},
                    {email: "Email", align: 'left'},
                ]
            }
        }
    }
</script>
